package services.storage.http

import it.neckar.rest.RestResponse
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for
 */
@Serializable
sealed interface FetchProjectResponse : RestResponse<FetchProjectInformation> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: FetchProjectInformation) : FetchProjectResponse, RestResponse.GoodResponse<FetchProjectInformation>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : FetchProjectResponse, RestResponse.BadResponse<FetchProjectInformation>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: FetchProjectInformation): FetchProjectResponse = Good(data)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): FetchProjectResponse = Failed

    /**
     * Creates a success method for non-null results, failure for null results
     */
    fun createFor(data: FetchProjectInformation?): FetchProjectResponse {
      return if (data != null) {
        good(data)
      } else {
        bad()
      }
    }

  }
}

